import React, { useState } from "react";
import Filters from "./Filters";
import Pagination from "./Pagination";
import ReportList from "./ReportList";
import { FaSearch } from "react-icons/fa";

function Listing() {
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [reportsPerPage] = useState(8);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalReports = 100;
  const totalPages = Math.ceil(totalReports / reportsPerPage);

  return (
    <>
      <div className="min-h-screen bg-blue-50">
        <div className="container mx-auto p-8">
          <div className="flex flex-col lg:flex-row lg:space-x-4">
            {/* <div className="w-full lg:w-1/4 mb-4 lg:mb-0">
              <Filters />
            </div> */}
            <div className="w-full lg:w-1/1">
              <div className="flex items-center w-full mb-4">
                <input
                  type="text"
                  placeholder="Search for any services"
                  className="w-full p-3 border border-gray-300 rounded-l font-euclid focus:outline-none"
                  value={searchQuery}
                  onChange={handleSearchChange}
                />
                <button className="border border-pink-500 bg-pink p-4 rounded-r text-white">
                  <FaSearch />
                </button>
              </div>
              <div
                style={{
                  overflow: "auto",
                  height: "70vh",
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                }}
              >
                <ReportList
                  searchQuery={searchQuery}
                  currentPage={currentPage}
                  reportsPerPage={reportsPerPage}
                />
              </div>
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Listing;
